var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/information/product-label-download/product-label-download.html';
var html = "<label style=color:rgba(0,0,0,.38)>Product Label *</label> <div ng-if=\"!$ctrl.labelChanged && $ctrl.fileType\"> <div ng-switch=$ctrl.fileType> <div ng-switch-when=image> <md-button class=md-primary ng-click=$ctrl.previewLabelImage($ctrl.product.ProductId)>{{$ctrl.product.FileLabelName}}</md-button> </div> <div ng-switch-when=pdf> <md-button class=md-primary ng-href={{$ctrl.download.DownloadUrl}} ng-if=\"$ctrl.download && $ctrl.download.DownloadUrl\">{{$ctrl.product.FileLabelName}}</md-button> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/product/information/product-label-download/product-label-download.html
// module id = 642
// module chunks = 0